<template>
	<div class="page">
		<div class="van-nav-bar van-nav-bar--fixed van-hairline--bottom" style="justify-content: space-between">
			<div class="left" style="display: flex; align-items: center">
				<VanImage
					class="logo"
					:src="require('../assets/logo3@2x.png')"/>
				<div class="search">
					<Search v-model="value" placeholder="输入您要找的内容" @focus="onFocus" >
						<template #left-icon>
							<div style="width: 25px"></div>
							<VanImage
								style="position: absolute; left: 2px"
								width="1.5rem"
								height="1.5rem"
								:src="require('../assets/search@2x.png')"/>
						</template>
					</Search>
				</div>
			</div>
			<div class="right">
				<Icon name="ellipsis" style="margin-right: 15px"></Icon>
			</div>
		</div>
		<div class="page-body">
			<Marquee />

			<Swipe
				v-if="false"
				class="my-swipe"
				:autoplay="3000"
				indicator-color="white">
			  <SwipeItem v-for="(item, index) in banners" :key="index">
				  <VanImage
              @click="toUrl(item)"
					  fit="fill"
					  height="100%"
					  :src="item.imgUrl"/>
			  </SwipeItem>
			</Swipe>
			<div class="split"></div>
			<Cell :border="false">
				<template #icon>
					<VanImage
						width="2.5rem"
						height="2.5rem"
						style="margin-right: 30px; margin-left: 10px; margin-top: 5px"
						:src="require('../assets/news.png')"/>
				</template>
				<Swipe style="height: 50px" vertical :show-indicators="false" :autoplay='2000'>
				  <SwipeItem v-for="(item, index) in headingNews" :key="index" @click="onHeadingClick(item)">
            <div class="d_flex">
              <VanImage
                  @click="toUrl(item)"
                  fit="fill"
                  width="40px"
                  height="40px"
                  :src="item.imageUrl"/>
              <div style="width: calc(100% - 50px)">
                <p class="NoWrap">{{ item.heading }}</p>
                <p>{{ item.publishTime }}</p>
              </div>
            </div>
				  </SwipeItem>
				</Swipe>
			</Cell>
			<div class="split"></div>

			<price-market-table :data="markets" />
			
			<div class="card" v-if="false">
				<Cell is-link value="更多" :border="false" @click="$router.push('trend')">
					<template #title><p class="card-title">行情走势</p></template>
				</Cell>
				<Swipe
					:autoplay="3000">
				  <SwipeItem>
					  <trendCard v-if="markets[0]" :data="markets && markets[0]" />
				  </SwipeItem>
				</Swipe>
			</div>
			<div class="split"></div>
			<div class="card">
				<Cell is-link value="更多" :border="false" @click="$router.push('market')">
					<template #title><p class="card-title">第三方服务市场</p></template>
				</Cell>
				<Cell v-for="(item, index) in goods" :key="index" @click="onItemClick(item)">
					<div class="box">
						  <VanImage
							  width="3rem"
							  height="3rem"
							  class="box-left"
							  :src="item.goodsImages && item.goodsImages[0].imageUrl"/>
						  <div class="box-right">
							  <p class="title">{{ item.goodsInfo.goodsName }}</p>
							  <p class="text"><span>服务费用：{{ item.goodsInfo.price }} /天</span><Button round size="small" type="danger" @click.stop="onBuyClick(item)">购买</Button></p>
						  </div>
					  </div>
				</Cell>
			</div>
			<div class="btn-wrap">
				<Button round block type="danger" plain @click="openNewUrl()">下载香肠树APP，进入【货者】10万人大群，进群邀请码3MELW</Button>
			</div>
		</div>
	</div>
</template>

<script>
  import { NavBar, Image as VanImage, Icon, Swipe, SwipeItem, Cell, Button, Search } from 'vant'
  import ChartLine from '../components/chartLine.vue'
  import trendCard from '../components/trendCard.vue'

  import PriceMarketTable from '@/components/PriceMarketTable.vue'
  import Marquee from '@/components/Marquee.vue'

  export default {
    components: { PriceMarketTable, Marquee, NavBar, Search, VanImage, Icon, Swipe, SwipeItem, Cell, Button, ChartLine, trendCard, Search },
    data () {
      return {
        searchText: '',
        value: ''
      }
    },
	  computed: {
      banners () {
        return this.$store.state.homeBanners.map(v => v)
      },
      goods () {
        return this.$store.state.homeGoods
      },
      headingNews () {
        return this.$store.state.homeHeadingNews
      },
		  markets () {
        return this.$store.state.homeMarkets
		  }
	  },
    methods: {
      toUrl (item) {
        window.location.href = item.linkUrl
      },
      openNewUrl () {
        window.location.href = 'http://www.xiangchangshu.com/index.html#download'
      },
      onClickLeft () {},
      onClickRight () {},
      onItemClick(target) {
        console.log(target)
        this.$router.push({
          name: 'goodDetail',
          query: {
            id: target.goodsInfo.id
          }
        })
      },
      onBuyClick(item) {
        this.$router.push({
          name: 'orderPay',
          params: { ...item }
        })
      },
      onHeadingClick(item) {
        this.$router.push({
          name: 'newsDetail',
          params: { ...item }
        })
      },
      onFocus() {
        this.$router.push('/tabs/market')
      }
    }
  }
</script>

<style lang="less" scoped>
	.page {
		padding-top: 46px;
	}
	.van-search {
		padding: 0;
	}
	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
		height: 120px;
		background-color: #fff;
	}
	p {
		margin: 0;
		line-height: 26px;
	}

	.card {
		&-title {
			text-align: left;
			font-weight: bold;
		}
	}

	.box {
		display: flex;

		&-left {
			padding-right: 15px;
		}

		.title {
			font-size: 14px;
			text-align: left;
			line-height: 20px;
		}

		.text {
			font-size: 12px;
			color: #646566;
			display: flex;
			justify-content: space-between;
		}
	}

	.btn-wrap {
		margin: 50px 30px;
	}

	.logo {
		width: 106px;
		height: 40px;
		margin: 0px 15px;
	}

	.search {
		.van-search__content {
			border-radius: 25px;
		}
	}
</style>
